import React, { useEffect, useState } from 'react'
import { authState } from 'atoms'
import { useRecoilState } from 'recoil'
import Button from '@material-ui/core/Button'
import { styled } from '@material-ui/core/styles'
import { Auth } from 'aws-amplify'

const IkeaButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  padding: '16px 6px',
  margin: '16px 0',
  border: '1px solid',
  lineHeight: 1.5,
  backgroundColor: '#0059d6',
  borderColor: '#0059d6',
  fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(','),
  '&:hover': {
    backgroundColor: '#0059d6',
    borderColor: '#0059d6',
    boxShadow: 'none',
  },
})

const Dashboard = () => {

  useEffect(() => {

  }, [])

  const onSubmit = async (e) => {
    e.preventDefault()
    try {
      await Auth.signOut()
    } catch (error) {
      console.log('error signing out: ', error)
    }
}

  return (
    <>
      <div className="content">
        <h1>Dashboard</h1>
        <form onSubmit={onSubmit}>
          <IkeaButton variant="contained" color="primary" fullWidth={true} size="large" type="submit">
            Sign out
          </IkeaButton>
        </form>
      </div>
      <style jsx>
        {`
          body {
          }
        `}
      </style>
    </>
  )
}

export default Dashboard